import { MDText } from 'i18n-react';

import LocalTexts from '../../../../texts.json';
import { MOT_CHECK_STATUS_CODES } from '../../../../Utilities/Services/motAPI.helpers';

const vrmErrorT = new MDText(LocalTexts);

const t = (key: string, options?: Record<string, unknown>) => vrmErrorT.translate(`hero.vrmForm.errors.${key}`, options) as string;

export const getVrmErrorTexts = (
  status: number,
  vrm?: string,
) => {
  const [title, detail] = {
    [MOT_CHECK_STATUS_CODES.INVALID_VRM]: [
      t('invalid_vrm.title', { vrm }),
      t('invalid_vrm.detail'),
    ],
    [MOT_CHECK_STATUS_CODES.NOT_FOUND]: [
      t('vehicle_lookup_failed.title'),
      t('vehicle_lookup_failed.detail'),
    ],
  }[status] || [
    t('default.title'),
    t('default.detail'),
  ];

  return { detail, title };
};
